module.exports = __webpack_public_path__ + "img/image_big_logo.b3244214.png";